import useIsBuyer from 'hooks/useIsBuyer';
import toast from 'utils/toast.jsx';
import IconMainContainer from 'components/IconMainContainer';
import useModalData from 'hooks/useModalData';
import OnlyFansVerificationDialog from '../profileVerification/OnlyFansVerificationDialog';
import useOnlyFansConnections from 'hooks/useOnlyFansConnections';

const OnlyFansC4Dialog = () => {
  const isBuyer = useIsBuyer();
  const { connectionId: reconnect } = useModalData('OnlyFans Verification');
  const { addConnection } = useOnlyFansConnections();

  const handleOnlyFansVerification = connection => {
    addConnection(connection);

    toast('success', `Successfully connected account ${connection.username}`, {
      icon: <IconMainContainer src="/icons/notifications/thumb-up.svg" alt="Thumb Up" />,
    });
  };

  return (
    <OnlyFansVerificationDialog
      title={`${reconnect ? 'RECONNECT' : 'CONNECT'} ONLYFANS`}
      subtitle="OnlyFans integration"
      description={
        <>
          By connecting automatically to OnlyFans, you'll unlock a range of benefits including:
          <ul
            style={{
              fontFamily: 'Avenir-Heavy',
              width: 'fit-content',
              margin: '15px 0 0 10px',
              textAlign: 'left',
            }}
          >
            <li>Real time data for sellers</li>
            <li>Special badge for buyers/sellers</li>
            <li>Seamless GG order flow</li>
            <li>Get extra data on OF purchases</li>
            <li>Priority placement in Discover for sellers</li>
          </ul>
        </>
      }
      handleSuccess={handleOnlyFansVerification}
      integration={isBuyer}
      sideWidth
    />
  );
};

export default OnlyFansC4Dialog;
